import { Footer } from '../../components/Footer/Footer';
import { LoginForm } from '../../components/LoginForm/LoginForm';
import { PageContainer } from '../../containers/PageContainer/PageContainer';

export const Login = () => (
  <PageContainer>
    <LoginForm />
    <Footer />
  </PageContainer>
);
